import React from 'react';

const MediaBackground = () => {
  return (
    <div className="fixed inset-0 z-[-10] overflow-hidden pointer-events-none bg-[#030712]">
      {/* 
        High-Resolution Space Image
        Using a beautiful image of Earth at night from space (relevant to remote sensing & ISRO)
      */}
      <img 
        src="/assets/images/space_bg.png" 
        alt="Space Nebula Background" 
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />
      
      {/* 
        Solid Dark Overlay 
        This is crucial to ensure the text on the website remains perfectly readable.
        We use a 75% opacity version of the site's dark background color so the nebula details are visible.
      */}
      <div className="absolute inset-0 bg-[#030712]/75" />
      
      {/* Optional: Subtle vertical gradient to make the bottom even darker for better contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#030712]/90" />
    </div>
  );
};

export default MediaBackground;
